import { createClient } from "@connectrpc/connect";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { PasswordResetService } from "../../../../generated/grpc/password_reset_pb";
import { OlvidePasswordRequest } from "../request/OlvidePasswordRequest";
import { mapPasswordResetGrpcError } from "./mapPasswordResetGrpcError";

/** Paso 1 de recuperación de contraseña: solicita el código OTP al email
 *  (`PasswordResetService.Olvidar`, gRPC-Web). No devuelve nada — en gRPC que
 *  el rpc no tire error ya es la señal de éxito, cargar un `{success:true}`
 *  sería dato sin uso (nada lo lee en `OlvidePasswordCardRender`). */
class OlvidePasswordGrpcService {
  async sendAsync(request: OlvidePasswordRequest): Promise<void> {
    const client = createClient(PasswordResetService, grpcTransportProvider.get());
    try {
      await client.olvidar({ email: request.email });
    } catch (error) {
      throw mapPasswordResetGrpcError(error);
    }
  }
}

/** Singleton del servicio del paso 1, variante gRPC (sin estado). */
export const olvidePasswordGrpcService = new OlvidePasswordGrpcService();
